import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from './blogPosts.generated';
import { setPageMeta } from './pageMeta';
import { BLOG_INDEX_DESCRIPTION } from './seoMeta';
import './Marketing.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function BlogIndex() {
  useEffect(() => {
    setPageMeta({
      title: 'Blog — Racontera',
      description: BLOG_INDEX_DESCRIPTION,
      path: '/blog',
      ogType: 'website',
      schema: 'Blog',
      blogPosts,
    });
  }, []);

  return (
    <div className="blog-index">
      <h1>Blog</h1>
      <p className="blog-index-intro">
        Updates on research-driven content, product news, and workflow tips.
      </p>
      {blogPosts.length === 0 ? (
        <p>No posts yet. Check back soon.</p>
      ) : (
        <ul className="blog-list">
          {blogPosts.map((post) => (
            <li key={post.slug} className="blog-list-item">
              <Link to={`/blog/${post.slug}`} className="blog-list-link">
                <h2>{post.title}</h2>
                <div className="blog-list-meta">{formatDate(post.date)}</div>
                {post.excerpt && <p className="blog-list-excerpt">{post.excerpt}</p>}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default BlogIndex;
